export default "__VITE_ASSET__DlzFqehp__";